<template>
  <div class="sidebar">
    <div v-if="user.role === 'user'" class="sidebar__list">
      <router-link
        v-for="(page, index) in content.user.pages"
        v-bind:class="[
          page.title === content.page
            ? 'sidebar__link sidebar__link_active'
            : 'sidebar__link',
        ]"
        exact-active-class=""
        active-class=""
        v-bind:key="index"
        v-bind:data-name="page.name"
        v-bind:to="page.path"
        @click="logout(page.name)"
      >
        <img
          class="sidebar__icon"
          :src="require(`../assets/images/${page.icon}.svg`)"
          alt=""
        />
        <span class="sidebar__badge" v-if="page.badge && page.badge !== null"
          >1</span
        >
      </router-link>
    </div>
    <div v-if="user.role === 'engineer'" class="sidebar__list">
      <router-link
        v-for="(page, index) in content.engineer.pages"
        v-bind:class="[
          page.title === content.page
            ? 'sidebar__link sidebar__link_active'
            : 'sidebar__link',
        ]"
        exact-active-class=""
        active-class=""
        v-bind:key="index"
        v-bind:data-name="page.name"
        v-bind:to="page.path"
        @click="logout(page.name)"
      >
        <img
          class="sidebar__icon"
          :src="require(`../assets/images/${page.icon}.svg`)"
          alt=""
        />
        <span class="sidebar__badge" v-if="page.badge && page.badge !== null"
          >1</span
        >
      </router-link>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from "vuex";

  export default {
    name: "Sidebar",
    watch: {
      "$route.path": function () {
        let payload = {
          role: this.user.role,
          page: this.$route.name,
        };

        this.changePage(payload);
      },
    },
    computed: {
      ...mapGetters({
        user: "getAuthorizationUser",
        content: "getCommonContent",
      }),
    },
    methods: {
      ...mapActions(["logoutAuthorization"]),
      ...mapMutations(["changePage"]),

      logout(name) {
        if (name === "Login") {
          this.logoutAuthorization().then(() => {
            this.$router.push("/login");
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .sidebar {
    @include base;

    padding: 8px;
    margin-right: 15px;
    display: none;

    @include mediaquery(sm) {
      display: block;
    }

    &__list {
      display: flex;
      flex-direction: column;
    }

    &__link {
      text-decoration: none;
      padding: 12px;
      border-bottom: 1px solid #d4d4d4;
      position: relative;

      &:last-of-type {
        border: 0;
      }

      &_active {
        .sidebar__icon {
          opacity: 1;
        }
      }
    }

    &__icon {
      width: 20px;
      height: 20px;
      opacity: 0.3;
    }

    &__badge {
      position: absolute;
      right: 0;
      top: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 17px;
      min-width: 17px;
      color: #fff;
      background-color: #93e046;
      font-size: 10px;
      border-radius: 10px;
      z-index: 100;
    }
  }
</style>
